@if (isVisible) {
<div class="edit-modal-overlay" (click)="onClose()">
  <div class="edit-modal-container" (click)="stopPropagation($event)">
    <div class="edit-modal-header">
      <h2>{{ 'Edit' | translate }}</h2>
      <button class="edit-modal-close-btn" (click)="onClose()" [attr.aria-label]="'Close' | translate">
        <span class="icon-close">&times;</span>
      </button>
    </div>
    <div class="edit-modal-tabs">
      <button class="tab-btn" [class.active]="activeModalTab === 'info'" (click)="setModalTab('info')">
        {{ 'General information' | translate }}
      </button>
      <button class="tab-btn" [class.active]="activeModalTab === 'fields'" (click)="setModalTab('fields')">
        {{ 'Fields' | translate }}
      </button>
    </div>
    <div class="edit-modal-body">
      @if (activeModalTab === 'info') {
      <form [formGroup]="editForm" class="tab-content-info">
        <div class="form-group">
          <label class="form-label">{{ 'Name' | translate }} *</label>
          <msf-input
            [model]="nameControl.value"
            (modelChange)="nameControl.setValue($event)"
            (onBlur)="nameControl.markAsTouched()"
            [placeholder]="'Name' | translate"
          />
        </div>
        <div class="form-group">
          <label class="form-label" for="edit-data-type">{{ 'Data type' | translate }}</label>
          <select id="edit-data-type" class="form-input" formControlName="dataTypeId">
            <option [ngValue]="null">{{ 'Select' | translate }}</option>
            @for (type of uavDataTypes; track type.id) {
            <option [value]="type.id">
              {{ type | serverTranslate:'names' }}
            </option>
            }
          </select>
        </div>
        <div class="form-group">
          <label class="form-label" for="edit-camera-type">{{ 'Camera type' | translate }}</label>
          <select id="edit-camera-type" class="form-input" formControlName="cameraTypeId">
            <option [ngValue]="null">{{ 'Select' | translate }}</option>
            @for (camera of cameraTypes; track camera.id) {
            <option [value]="camera.id">
              {{ camera | serverTranslate:'names' }}
            </option>
            }
          </select>
        </div>
        <div class="form-group">
          <label class="form-label" for="edit-comment">{{ 'Comment' | translate }}</label>
          <textarea id="edit-comment" class="form-textarea" rows="3" [placeholder]="'Comment' | translate"
            formControlName="comment"></textarea>
        </div>
        <div class="form-group">
          <label class="form-label">{{ 'Tags' | translate }}</label>
          <app-tag-selector
            [selectedTagIds]="editForm.get('tagIds')?.value || []"
            (selectedTagIdsChange)="editForm.get('tagIds')?.setValue($event)"
            [allowCreate]="true"
            [placeholder]="'Select tags' | translate"></app-tag-selector>
        </div>
      </form>
      }

      @else if (activeModalTab === 'fields') {
      <div class="tab-content-fields">
        <div class="fields-header">
<!--          <button class="btn btn-primary btn-add-field" (click)="openAddFieldModal()">-->
<!--            <span class="icon-plus">+</span> {{ 'Add' | translate }}-->
<!--          </button>-->

          <app-primary-button
            width="100%"
            title="Add"
            size="small"
            icon="pi pi-plus"
            (action)="openAddFieldModal()"
            [disable]="isSaving"
          ></app-primary-button>

          <app-secondary-button
            title="{{ isRecalculating ? ('Processing...' | translate) : ('Recalculate' | translate) }}"
            width="100%"
            size="small"
            icon="pi pi-refresh"
            [disable]="isRecalculating || isLoadingFields"
            (action)="onRecalculateRelations()"
          ></app-secondary-button>

<!--          <button class="btn btn-secondary btn-recalculate" (click)="onRecalculateRelations()"-->
<!--            [disabled]="isRecalculating || isLoadingFields">-->
<!--            <span class="icon-refresh" [class.spinning]="isRecalculating"></span>-->
<!--            {{ isRecalculating ? ('Processing...' | translate) : ('Recalculate' | translate) }}-->
<!--          </button>-->
        </div>
        <div class="fields-table-header">
          <span>{{ 'Name' | translate }}</span>
          <span>{{ 'Culture' | translate }}</span>
          <span>{{ 'SKTP' | translate }}</span>
          <span class="actions-header"></span>
        </div>
        <div class="fields-list">
          @if (isLoadingFields) {
          <div class="no-data-row" style="padding: 12px; text-align: center;">
            {{ 'Loading...' | translate }}
          </div>
          }
          @else if (linkedFields.length > 0) {
          @for (item of linkedFields; track item.relationId) {
          <div class="field-row">
            <div class="field-cell field-info" (click)="navigateToField(item.fieldId)">
              <span class="field-cadastre" [title]="item.fieldName">
                {{ item.fieldName }}
              </span>
            </div>
            <div class="field-cell field-culture">
              <span [title]="item.cropName" style="color: #14151a;">
                {{ item.cropName }}
              </span>
            </div>
            <div class="field-cell field-producer">
              <span [title]="item.firmName" style="color: #14151a;">
                {{ item.firmName }}
              </span>
            </div>
            <div class="field-cell field-actions">
              <button class="btn btn-icon btn-field-action" (click)="deleteFieldRelation(item.fieldId, item.relationId)"
                [attr.aria-label]="'Delete' | translate">
                <span class="icon-delete-field"></span>
              </button>
            </div>
          </div>
          }
          }
          @else {
          <div class="no-data-row" style="padding: 12px; text-align: center; color: #666; font-size: 14px;">
            {{ 'No fields linked' | translate }}
          </div>
          }
        </div>
      </div>
      }
    </div>
    <div class="edit-modal-footer">

      <app-primary-button
        title="{{ isSaving ? ('Saving...' | translate) : ('Save' | translate) }}"
        (action)="onEditSubmit()"
        [disable]="isSaving"
      ></app-primary-button>

      <app-secondary-button
        title="Cancel"
        (action)="onClose()"
      ></app-secondary-button>
<!--      <button class="btn btn-secondary" (click)="onClose()">{{ 'Cancel' | translate }}</button>-->
<!--      <button class="btn btn-primary" (click)="onEditSubmit()" [disabled]="isSaving">-->
<!--        {{ isSaving ? ('Saving...' | translate) : ('Save' | translate) }}-->
<!--      </button>-->
    </div>
  </div>
</div>
}
<app-uav-add-field-modal [isVisible]="isAddFieldModalVisible" (close)="closeAddFieldModal()"
  (save)="onFieldSaved($event)">
</app-uav-add-field-modal>

<app-confirmation-modal [isVisible]="isConfirmVisible" [title]="confirmConfig.title | translate"
  [message]="confirmConfig.message | translate" [confirmText]="'Yes' | translate" [cancelText]="'No' | translate"
  (confirm)="onConfirmAction()" (cancel)="closeConfirmModal()">
</app-confirmation-modal>
